import request from "@/utils/request";

// 用户反馈
export function sendVoice(data) {
  return request({
    url: '/api/your-voice',
    method: "post",
    data: data,
  });
}


// 获取国家码
export function getAreaCodeApi() {
  return request({
    url: '/api/area_codes?sort=sort',
    method: "get",
  });
}

// 注册
export function Register(data) {
  return request({
    url: '/api/agent/signup',
    method: "post",
    data
  });
}

// 提交
export function Contact(data) {
  return request({
    url: '/api/contact',
    method: "post",
    data
  });
}